var _rect, _g, _path, _g2, _circle, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 85,
    viewBox: "0 0 82 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1349_3905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "url(#paint0_linear_1349_3905)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1349_3905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 47.5C11.8354 47.5 8.75781 46.2531 6.20469 43.7594C3.65156 41.2656 2.375 38.2177 2.375 34.6156C2.375 31.5281 3.30521 28.7771 5.16563 26.3625C7.02604 23.9479 9.46042 22.4042 12.4688 21.7313C13.4583 18.0896 15.4375 15.1406 18.4062 12.8844C21.375 10.6281 24.7396 9.5 28.5 9.5C33.1313 9.5 37.0599 11.113 40.2859 14.3391C43.512 17.5651 45.125 21.4937 45.125 26.125C47.8562 26.4417 50.1224 27.6193 51.9234 29.6578C53.7245 31.6964 54.625 34.0813 54.625 36.8125C54.625 39.7812 53.5859 42.3047 51.5078 44.3828C49.4297 46.4609 46.9062 47.5 43.9375 47.5H15.4375ZM15.4375 42.75H43.9375C45.6 42.75 47.0052 42.176 48.1531 41.0281C49.301 39.8802 49.875 38.475 49.875 36.8125C49.875 35.15 49.301 33.7448 48.1531 32.5969C47.0052 31.449 45.6 30.875 43.9375 30.875H40.375V26.125C40.375 22.8396 39.2172 20.0391 36.9016 17.7234C34.5859 15.4078 31.7854 14.25 28.5 14.25C25.2146 14.25 22.4141 15.4078 20.0984 17.7234C17.7828 20.0391 16.625 22.8396 16.625 26.125H15.4375C13.1417 26.125 11.1823 26.9365 9.55938 28.5594C7.93646 30.1823 7.125 32.1417 7.125 34.4375C7.125 36.7333 7.93646 38.6927 9.55938 40.3156C11.1823 41.9385 13.1417 42.75 15.4375 42.75Z",
    fill: "url(#paint1_linear_1349_3905)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0992 66.576C17.4096 66.576 15.7328 66.4096 14.0688 66.0768C12.4048 65.7696 11.0352 65.3344 9.96 64.7712V58.6656C11.3424 59.3824 12.776 59.92 14.2608 60.2784C15.7712 60.6368 17.2048 60.816 18.5616 60.816C19.816 60.816 20.7632 60.624 21.4032 60.24C22.0432 59.856 22.3632 59.3056 22.3632 58.5888C22.3632 58.0512 22.184 57.5904 21.8256 57.2064C21.4928 56.7968 20.9936 56.4256 20.328 56.0928C19.6624 55.76 18.6256 55.2992 17.2176 54.7104C14.7344 53.6608 12.9296 52.496 11.8032 51.216C10.6768 49.936 10.1136 48.3616 10.1136 46.4928C10.1136 44.9568 10.536 43.5872 11.3808 42.384C12.2512 41.1808 13.4544 40.2464 14.9904 39.5808C16.5264 38.9152 18.2928 38.5824 20.2896 38.5824C21.928 38.5824 23.3872 38.7104 24.6672 38.9664C25.9472 39.2224 27.176 39.632 28.3536 40.1952V46.1472C26.1008 44.9696 23.8352 44.3808 21.5568 44.3808C20.328 44.3808 19.3424 44.5856 18.6 44.9952C17.8832 45.3792 17.5248 45.9424 17.5248 46.6848C17.5248 47.4272 17.896 48.0288 18.6384 48.4896C19.3808 48.9504 20.7504 49.5776 22.7472 50.3712C24.5648 51.1136 25.9728 51.8432 26.9712 52.56C27.9952 53.2768 28.7376 54.1088 29.1984 55.056C29.6592 56.0032 29.8896 57.2064 29.8896 58.6656C29.8896 61.1488 28.9808 63.0944 27.1632 64.5024C25.3712 65.8848 22.6832 66.576 19.0992 66.576ZM46.2609 66.576C43.5473 66.576 41.0897 65.9872 38.8881 64.8096C36.7121 63.632 34.9841 61.9936 33.7041 59.8944C32.4497 57.7696 31.8225 55.3376 31.8225 52.5984C31.8225 49.8592 32.4497 47.4272 33.7041 45.3024C34.9841 43.1776 36.7121 41.5264 38.8881 40.3488C41.0897 39.1712 43.5473 38.5824 46.2609 38.5824C48.9489 38.5824 51.3809 39.1712 53.5569 40.3488C55.7585 41.5264 57.4865 43.1776 58.7409 45.3024C59.9953 47.4272 60.6225 49.8592 60.6225 52.5984C60.6225 55.3376 59.9953 57.7696 58.7409 59.8944C57.4865 61.9936 55.7585 63.632 53.5569 64.8096C51.3809 65.9872 48.9489 66.576 46.2609 66.576ZM46.2609 60.2016C47.6177 60.2016 48.8593 59.8944 49.9857 59.28C51.1121 58.6656 52.0081 57.7824 52.6737 56.6304C53.3393 55.4784 53.6721 54.1344 53.6721 52.5984C53.6721 51.0624 53.3393 49.7312 52.6737 48.6048C52.0337 47.4528 51.1505 46.5696 50.0241 45.9552C48.8977 45.3152 47.6433 44.9952 46.2609 44.9952C44.8529 44.9952 43.5857 45.3152 42.4593 45.9552C41.3329 46.5696 40.4369 47.4528 39.7713 48.6048C39.1313 49.7312 38.8113 51.0624 38.8113 52.5984C38.8113 54.1344 39.1313 55.4784 39.7713 56.6304C40.4369 57.7824 41.3329 58.6656 42.4593 59.28C43.6113 59.8944 44.8785 60.2016 46.2609 60.2016ZM62.535 69.5712C64.8134 67.984 66.3622 66.832 67.1814 66.1152C68.0006 65.424 68.4102 64.784 68.4102 64.1952C68.4102 63.8112 68.2694 63.5296 67.9878 63.3504C67.7318 63.1712 67.3222 63.0816 66.759 63.0816C66.119 63.0816 65.4534 63.1968 64.7622 63.4272C64.071 63.6576 63.4822 63.952 62.9958 64.3104V60.3552C63.5078 60.0224 64.2374 59.7408 65.1846 59.5104C66.1318 59.28 67.0406 59.1648 67.911 59.1648C69.703 59.1648 71.0598 59.5744 71.9814 60.3936C72.9286 61.1872 73.4022 62.1856 73.4022 63.3888C73.4022 64.3616 73.0822 65.2192 72.4422 65.9616C71.8278 66.6784 70.7398 67.6128 69.1782 68.7648H73.6326V72.1824H62.535V69.5712Z",
    fill: "url(#paint2_linear_1349_3905)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1349_3905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 31.5,
    r: 6.5,
    fill: "url(#paint3_linear_1349_3905)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 31.5,
    r: 7.30841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 27.5,
    r: 6.30841,
    fill: "url(#paint4_linear_1349_3905)",
    stroke: "white",
    strokeWidth: 1.61682
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1349_3905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 23,
    r: 3,
    fill: "url(#paint5_linear_1349_3905)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 23,
    r: 3.80841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1349_3905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 15,
    r: 3,
    fill: "url(#paint6_linear_1349_3905)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 15,
    r: 3.80841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1349_3905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 48.5,
    r: 4.5,
    fill: "url(#paint7_linear_1349_3905)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 48.5,
    r: 5.30841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1349_3905",
    x: 54.3833,
    y: 19.3833,
    width: 24.2334,
    height: 24.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1349_3905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1349_3905",
    x: 37.3833,
    y: 18.3833,
    width: 17.2334,
    height: 17.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1349_3905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1349_3905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1349_3905",
    x: 57.3833,
    y: 6.3833,
    width: 17.2334,
    height: 17.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1349_3905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1349_3905",
    x: 61.3833,
    y: 38.3833,
    width: 20.2334,
    height: 20.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1349_3905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1349_3905",
    x1: 28.5,
    y1: 0,
    x2: 28.5,
    y2: 65.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1349_3905",
    x1: 28.5,
    y1: 9.5,
    x2: 28.5,
    y2: 53.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1349_3905",
    x1: 9,
    y1: 27,
    x2: 87.7502,
    y2: 47.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1349_3905",
    x1: 60,
    y1: 26.2187,
    x2: 75.5728,
    y2: 30.2363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1349_3905",
    x1: 50,
    y1: 23.0312,
    x2: 63.177,
    y2: 26.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1349_3905",
    x1: 43,
    y1: 20.5625,
    x2: 50.1875,
    y2: 22.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1349_3905",
    x1: 63,
    y1: 12.5625,
    x2: 70.1875,
    y2: 14.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1349_3905",
    x1: 67,
    y1: 44.8437,
    x2: 77.7812,
    y2: 47.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSo2);
export default __webpack_public_path__ + "static/media/SO2.18aae06f30a63b745e1d512ba05a3ffd.svg";
export { ForwardRef as ReactComponent };